import { readAsList } from '@one-vision/json-api-parser';
import { apiClient } from 'core/api';
import { AppThunk } from 'core/redux';
import { getNextPage } from 'core/redux/reducers/helpers';
import UserGroups from 'core/redux/reducers/userGroups';
import { ListReducerState } from 'core/redux/reducers/types';

export const fetchUserGroups =
  (options: Partial<ListReducerState> = {}, listId?: string): AppThunk =>
  async (dispatch, getState) => {
    const state = getState();
    const listState = UserGroups.selectors.selectList(state, listId || '');
    const nextPage = getNextPage(options.page, listState);

    const limit = options.perPage || listState.perPage;
    const offset = limit * (nextPage - 1);

    delete options.perPage;
    const apiResponse = await apiClient.getUserGroups({
      include: listState.include,
      search: listState.search,
      ...options,
      page: {
        limit,
        offset,
      },
    });
    const {
      data: { meta: responseMeta },
    } = apiResponse;

    const { entities } = readAsList(apiResponse.data);

    const { UserGroup } = entities;

    if (UserGroup && responseMeta) {
      const { page, defaultPage, ...meta } = responseMeta;
      dispatch(
        UserGroups.actions.batch([
          UserGroups.actions.updateList(
            {
              ...meta,
              ids: UserGroup.map((group) => group.id),
              page: page ? page.offset / page.limit + 1 : nextPage,
              perPage: page ? +page.limit : listState.perPage,
              lastPage: Math.ceil(
                meta.totalCount / (page ? page.limit : listState.perPage),
              ),
            },
            listId,
          ),
          UserGroups.actions.upsertMany(UserGroup),
        ]),
      );
    }
  };
